<template>
  <div class="locationAdd">
    <LoadingPlaceholder v-if="loading" />
    <form v-else>
      <div class="form-group">
        <h4 class="m-0 mt-3">
          {{ "Location" }}
        </h4>
        <hr class="m-0 mb-3" />
        <label>Altitude</label>
        <input
          v-model="location.location.altitude"
          class="form-control"
          type="text"
        />
        <hr class="m-0 mb-3" />
        <label>Latitude</label>
        <input
          v-model="location.location.latitude"
          class="form-control"
          type="text"
        />
        <hr class="m-0 mb-3" />
        <label>Longitude</label>
        <input
          v-model="location.location.longitude"
          class="form-control"
          type="text"
        />
        <hr class="m-0 mb-3" />
      </div>
      <LoadingPlaceholder v-if="upsertLoading" />
      <button
        v-else
        class="btn btn-primary float-right"
        @click.prevent="addLocation()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="check"
        />{{ $t("add") }}
      </button>
      <div class="clearfix" />
    </form>
  </div>
</template>

<script>
import { errorMixin } from "@/mixins/errorMixin.js";

export default {
  name: "LocationAdd",
  mixins: [errorMixin],
  props: {
    resortId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      location: {
        location: {
        },
      },
    };
  },
  methods: {
    async addLocation() {
      this.upsertLoading = true;
      this.location.resortId = this.resortId;
      await this.axios
        .post("/Resort/CreateResortLocation", this.location)
        .then(() => {
          this.$snotify.success(
            "Added location"
          );
          this.$emit("reload");
          this.error_clear();
          this.upsertLoading = false;
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    },
  },
};
</script>

<style scoped>
.locationAdd .progress {
  display: flex;
  flex: 1 1 auto;
  width: 1%;
  height: 20px;
  font-size: 1rem;
}
</style>
